import { render, staticRenderFns } from "./QRWalletPaymentDialog.vue?vue&type=template&id=dae5e50a&scoped=true&"
import script from "./QRWalletPaymentDialog.vue?vue&type=script&lang=js&"
export * from "./QRWalletPaymentDialog.vue?vue&type=script&lang=js&"
import style0 from "./QRWalletPaymentDialog.vue?vue&type=style&index=0&id=dae5e50a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae5e50a",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QSpinner,QLinearProgress});qInstall(component, 'directives', {ClosePopup});
